import InvoiceView from './InvoiceViewContainer';
export default InvoiceView;
